<template>
	<AppDialog v-model="isOpen">
		<div class="tw-rounded-lg tw-p-4" style="width: 600px">
			<div class="tw-pb-4">
				<div class="tw-text-lg tw-font-semibold">{{ $t('integrations.noon-project-id') }}</div>
				<div class="tw-text-gray-600">
					{{ $t('integrations.how-to-find-your-noon-project-id') }}
				</div>
			</div>

			<ol
				class="tw-flex tw-flex-col tw-gap-4 tw-px-4"
				type="1"
				start="1"
				style="list-style: decimal"
			>
				<li class="tw-border-b tw-border-b-gray-300 tw-pb-4">
					<div class="tw-flex tw-items-center">
						<span>{{ $t('integrations.visit-noon-project-page') }}</span>
						<a
							class="tw-cursor-pointer tw-ps-1 tw-text-blue-500 tw-underline hover:tw-underline"
							href="https://welcome.noon.partners/ar/organizations/"
							target="_blank"
							>{{ $t('integrations.here') }}</a
						>
					</div>
				</li>
				<li class="tw-border-b tw-border-b-gray-300 tw-pb-4">
					<div class="tw-flex tw-flex-col">
						<div>{{ $t('integrations.you-will-find-your-project-id') }}</div>
						<AppImage
							:src="loadFile('assets/v2/image/noon-integration/noon-help-project-id.png')"
							width="550px"
							class="tw-rounded-lg"
						/>
					</div>
				</li>
				<li>
					<div>{{ $t('integrations.copy-it-and-paste-in-project-id') }}</div>
				</li>
			</ol>

			<div class="tw-mt-4 tw-flex tw-items-center tw-justify-between">
				<a
					href="https://noon-docs.noonpartners.dev/docs/authentication/getting-credentials"
					target="_blank"
					class="tw-text-blue-500 tw-underline hover:tw-underline"
				>
					{{ $t('integrations.view-noon-documentation') }}
				</a>
				<AppButton :label="$t('close')" variant="gray" secondary @click="isOpen = false" />
			</div>
		</div>
	</AppDialog>
</template>

<script setup>
import AppDialog from '@/v2/components/dialog.vue';
import { ref } from 'vue';
import { loadFile } from '@/v2/utils/index';

const isOpen = ref(false);

const open = () => {
	isOpen.value = true;
};

defineExpose({
	open,
});
</script>

<style lang="scss" scoped></style>
